import React, { createContext, useContext } from 'react';

// Context so ProjectAnalytics can provide votes + handler once,
// and all 154 FeatureVoteCard instances consume without individual props.
export const FeatureVoteContext = createContext({ votes: {}, onVote: () => {} });

const OPTIONS = [
  { value: '', label: '— Rate this feature —' },
  { value: 'yes', label: 'Yes' },
  { value: 'yes_needs_work', label: 'Yes but needs more work' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'no', label: 'No' },
  { value: 'not_sure', label: 'Not sure what this is' },
];

const VOTE_COLORS = {
  yes: '#16a34a',
  yes_needs_work: '#2563eb',
  maybe: '#f59e0b',
  no: '#dc2626',
  not_sure: '#9ca3af',
};

const styles = {
  wrapper: {
    marginBottom: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    overflow: 'hidden',
    background: '#fff',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 16px',
    background: '#f8fafc',
    borderBottom: '1px solid #e5e7eb',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    flexWrap: 'wrap',
  },
  number: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#1f2937',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 700,
    flexShrink: 0,
  },
  name: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#374151',
    flex: 1,
    minWidth: '150px',
  },
  select: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    background: '#fff',
    color: '#374151',
    cursor: 'pointer',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    outline: 'none',
  },
  voteBadge: {
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '9999px',
    color: '#fff',
  },
  body: {
    padding: '0',
  },
};

export default function FeatureVoteCard({ number, name, children }) {
  const { votes, onVote } = useContext(FeatureVoteContext);
  const currentVote = votes[number] || '';
  const badgeColor = VOTE_COLORS[currentVote] || null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <span style={styles.number}>{number}</span>
        <span style={styles.name}>{name}</span>
        {badgeColor && (
          <span style={{ ...styles.voteBadge, background: badgeColor }}>
            {OPTIONS.find(o => o.value === currentVote)?.label}
          </span>
        )}
        <select
          style={styles.select}
          value={currentVote}
          onChange={(e) => onVote(number, e.target.value)}
        >
          {OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div style={styles.body}>
        {children}
      </div>
    </div>
  );
}
